const styles = {
  chip: {
    color: "green.main",
    textTransform: "uppercase",
    width: "max-content",
    backgroundColor: "white",
    border: "1px solid",
  },
  addButton: {
    px: 2,
    width: "max-content",
    backgroundColor: "white",
    border: "1px solid",
    color: "black",
    "&:hover": {
      backgroundColor: "white",
      border: "1px solid",
      color: "black",
    },
  },
};

export default styles;
